import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import { HeadingContextProvider } from "../context/HeadingContext";
import Error404 from "../pages/error/Error404";
import ShopAccountDashboard from "../pages/shop-account/ShopAccountDashboard";
import SchedulePage from "../pages/shop-account/Schedule/SchedulePage";

const ShopAccountRoutes = () => {
  return (
    <HeadingContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ShopAccountDashboard />}>
            <Route path="/" element={<SchedulePage />} />
            <Route path="/shop-schedule" element={<SchedulePage />} />
            {/* <Route path="/orders/:id" element={<OrderDetailsPage />} /> */}
            <Route path="*" element={<Error404 />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HeadingContextProvider>
  );
};
export default ShopAccountRoutes;
